import { slotObjectToDataTestIds } from '@elliemae/ds-system';

export const DSCircularIndeterminateIndicatorName = 'DSCircularindeterminateindicator';

export const DSCircularIndeterminateIndicatorSlots = {
  ROOT: 'root',
  SVG: 'svg',
  LABEL: 'label',
};

export const sizeToPx = {
  xs: 16,
  s: 24,
  m: 32,
  l: 48,
  xl: 56,
  xxl: 64,
};

export const sizeToWeight = {
  xs: '3px',
  s: '3px',
  m: '3px',
  l: '4px',
  xl: '5px',
  xxl: '6px',
};

export const colorToHex = {
  light: '#EBF6FF',
  dark: '#1394E5',
};

export const sizeToTextSize = {
  xs: '12px',
  s: '12px',
  m: '12px',
  l: '13px',
  xl: '14px',
  xxl: '16px',
};

export const DSCircularIndeterminateIndicatorDataTestIds = slotObjectToDataTestIds(
  DSCircularIndeterminateIndicatorName,
  DSCircularIndeterminateIndicatorSlots,
);
